import script from "./preference.vue?vue&type=script&setup=true&lang=js"
export * from "./preference.vue?vue&type=script&setup=true&lang=js"

import "./preference.vue?vue&type=style&index=0&id=d0d5a898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0d5a898"]])

export default __exports__